import { A11yModule } from '@angular/cdk/a11y';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AntragModalComponent } from './antrag-modal/antrag-modal.component';
import { AppRoute, BypassSecurityPipe, ByteToMegaBytePipe, goToDashboardIfLoggedIn } from '@ebeihilfe/core';
import { BelegComponent } from './beleg-selection/beleg/beleg.component';
import { BelegSelectionComponent } from './beleg-selection/beleg-selection.component';
import { ClosingScreenComponent } from './closing-screen/closing-screen.component';
import { CommonModule } from '@angular/common';
import { ConfirmationStepComponent } from './confirmation-step/confirmation-step.component';
import { ConverterService, EndToEndEncrypter, PendingChangesGuard, SimpleProgressComponent } from '@ebeihilfe/core';
import { CustomComponentModule } from '../../components/component.module';
import { DynamicFormComponent } from '@ebeihilfe/forms';
import {
  EINREICHUNG_COMPONENT,
  EinreichungComponentType,
  EinreichungService,
  OldCoreEinreichungModule,
  SeiteFactory,
} from '@ebeihilfe/einreichung-old';
import { EinreichungApiService } from '@eBeihilfe/einreichung-shared/services';
import { KurzantragComponent } from './kurzantrag/kurzantrag.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { ModuleWithProviders, NgModule, Optional, SkipSelf, Type } from '@angular/core';
import { PopulateUnfinishedAntragComponent } from './populate-unfinished-antrag/populate-unfinished-antrag.component';
import { PortalEinreichungComponent } from './portal-einreichung.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { StartPageComponent } from '../pages/start-page/start-page.component';
import { StartupInformationComponent } from './startup-information/startup-information.component';
import { StepperModule } from './stepper/stepper.module';
import { TranslateModule } from '@ngx-translate/core';
import { UploadComponent } from './upload/upload.component';
import { WebSeiteFactory } from './WebSeiteFactory';

@NgModule({
  declarations: [
    BelegSelectionComponent,
    UploadComponent,
    PortalEinreichungComponent,
    BelegComponent,
    ClosingScreenComponent,
    ConfirmationStepComponent,
    StartupInformationComponent,
    KurzantragComponent,
  ],
  exports: [ConfirmationStepComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    AngularSvgIconModule,
    CustomComponentModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    MatExpansionModule,
    MatProgressBarModule,
    SimpleProgressComponent,
    MatCardModule,
    OldCoreEinreichungModule,
    RouterModule.forChild([
      {
        component: PortalEinreichungComponent,
        path: AppRoute.EinreichungOld,
        canDeactivate: [PendingChangesGuard],
        data: { title: 'page_names.startseite' },
      },
      {
        path: '',
        pathMatch: 'full',
        component: StartPageComponent,
        canActivate: [goToDashboardIfLoggedIn],
        data: { title: 'page_names.startseite' },
      },
    ]),
    MatNativeDateModule,
    MatDividerModule,
    MatRadioModule,
    A11yModule,
    StepperModule,
    MatSelectModule,
    PopulateUnfinishedAntragComponent,
    AntragModalComponent,
    DynamicFormComponent,
    BypassSecurityPipe,
    ByteToMegaBytePipe,
  ],
  providers: [
    EinreichungService,
    {
      provide: SeiteFactory,
      useFactory: (): WebSeiteFactory => new WebSeiteFactory(),
      deps: [EinreichungApiService, EndToEndEncrypter, ConverterService],
    },
  ],
})
export class EinreichungOldModule {
  constructor(@Optional() @SkipSelf() parentModule: EinreichungOldModule) {
    if (parentModule) {
      // todo do we need to prevent this from being imported multiple times?
    }
  }

  public static forRoot(steps: Type<EinreichungComponentType>[] = []): ModuleWithProviders<EinreichungOldModule> {
    const providers = steps.map((step: Type<EinreichungComponentType>) => ({
      provide: EINREICHUNG_COMPONENT,
      multi: true,
      useClass: step,
    }));

    return {
      ngModule: EinreichungOldModule,
      providers: [
        {
          provide: EINREICHUNG_COMPONENT,
          multi: true,
          useClass: PopulateUnfinishedAntragComponent,
        },
        {
          provide: EINREICHUNG_COMPONENT,
          multi: true,
          useClass: StartupInformationComponent,
        },
        {
          provide: EINREICHUNG_COMPONENT,
          multi: true,
          useClass: BelegSelectionComponent,
        },
        {
          provide: EINREICHUNG_COMPONENT,
          multi: true,
          useClass: UploadComponent,
        },
        {
          provide: EINREICHUNG_COMPONENT,
          multi: true,
          useClass: ClosingScreenComponent,
        },
        ...providers,
      ],
    };
  }
}
